import { setElementTestId } from '../dom';
import { getApplicationSwitcherIcon } from './get-application-switcher-icon';
// import { getMedalliaIcon } from './get-medallia-icon';
// import { getIntegrationIcon } from './get-integration-icon';
export const getNavIcon = (options, handler) => {
    // const getOption = getOptionFunc(options);
    // const iconSizePx = getOption<number>('iconSizePx');
    const icon = document.createElement('div');
    icon.style.position = 'relative';
    icon.style.cursor = 'pointer';
    setElementTestId(icon, 'm_app_switcher_nav_icon');
    const appSwitcherIcon = document.createElement('div');
    appSwitcherIcon.style.zIndex = '1';
    appSwitcherIcon.style.position = 'relative';
    appSwitcherIcon.style.right = '10px';
    appSwitcherIcon.style.top = '3px';
    appSwitcherIcon.innerHTML = getApplicationSwitcherIcon(options);
    // const medalliaIcon = document.createElement('div');
    // medalliaIcon.style.zIndex = '1';
    // medalliaIcon.style.position = 'absolute';
    // medalliaIcon.style.right = '10px';
    // medalliaIcon.style.top = '0';
    // medalliaIcon.innerHTML = getMedalliaIcon(options);
    // const integrationIcon = document.createElement('div');
    // integrationIcon.style.position = 'relative';
    // integrationIcon.style.top = `${iconSizePx * 0.775}px`;
    // integrationIcon.style.left = `${-iconSizePx * 0.33}px`;
    // integrationIcon.innerHTML = getIntegrationIcon(options, { opacity: 0.25 });
    icon.addEventListener('click', handler);
    // icon.appendChild(integrationIcon);
    icon.appendChild(appSwitcherIcon);
    return icon;
};
